module.exports = __webpack_public_path__ + "img/whats-new-15_jp.cfa72a6.jpg";